export type IrrigationSystemFlowRateType = 'NOMINAL' | 'FLOW';

export const IrrigationSystemFlowRateType = {
  NOMINAL: 'NOMINAL' as IrrigationSystemFlowRateType,
  FLOW: 'FLOW' as IrrigationSystemFlowRateType,
};
